import { useEffect, useState } from "react";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import { adminMe, getToken } from "@/admin/api";

export default function Admin() {
  // null = checking, true = authed, false = not authed
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setAuthed(false);
      return;
    }
    adminMe()
      .then(() => setAuthed(true))
      .catch(() => setAuthed(false));
  }, []);

  if (authed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] text-[#5C5C5C]">
        Loading…
      </div>
    );
  }

  return authed ? (
    <AdminDashboard onLogout={() => setAuthed(false)} />
  ) : (
    <AdminLogin onLoggedIn={() => setAuthed(true)} />
  );
}
